import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

function getSessionId() {
  let sid = sessionStorage.getItem('cb_session');
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('cb_session', sid);
  }
  return sid;
}

export function usePageTracker() {
  const location = useLocation();
  const lastPage = useRef('');

  useEffect(() => {
    const page = location.pathname;
    if (page === lastPage.current) return;
    lastPage.current = page;

    api.post('/track/visit', {
      page,
      session_id: getSessionId(),
      referrer: document.referrer || '',
      user_agent: navigator.userAgent || '',
    }).catch(() => {});
  }, [location.pathname]);
}
